import { render, staticRenderFns } from "./carType.vue?vue&type=template&id=36b38f55&scoped=true&"
import script from "./carType.vue?vue&type=script&lang=js&"
export * from "./carType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b38f55",
  null
  
)

export default component.exports